export const robots = [
  {
    id: 1,
    name: 'Aanya Maheshwari',
    username: 'Dwarf',
    email: 'JustDwarf@gmail.com'
  },
  {
    id: 2,
    name: 'Adya Halde',
    username: 'AdityaRaj',
    email: 'AdityaRaj@gmail.com'
  },
  {
    id: 3,
    name: 'Arnav Khokarale',
    username: 'Samantha',
    email: 'Maggi@gmail.com'
  },
  {
    id: 4,
    name: 'Ayush Alhat',
    username: 'Karianne',
    email: 'IsAGirl@gmail.com'
  },
  {
    id: 5,
    name: 'Daksh Sharma',
    username: 'Kamren',
    email: 'NoShit@gmail.com'
  },
  {
    id: 6,
    name: 'Devesh Udhapye',
    username: 'Leopoldo_Corkery',
    email: 'DhoniSuckz@gmail.com'
  },
  {
    id: 7,
    name: 'Devika Deulgaonkar',
    username: 'Elwyn.Skiles',
    email: 'ForgotHerExistence@gmail.com'
  },
  {
    id: 8,
    name: 'Ethan Mathew',
    username: 'Maxime_Nienow',
    email: 'Mathuthuthuthu@gmail.com'
  },
  {
    id: 9,
    name: 'Eywa Shakyavanshi',
    username: 'Delphine',
    email: 'IsGayButDoesentSlay@gmail.com'
  },
  {
    id: 10,
    name: 'Gunika Malik',
    username: 'Moriah.Stanton',
    email: 'DontVote4Malik@gmail.com'
  },
  {
    id: 11,
    name: 'Karan Mhetar',
    username: 'Delphine',
    email: 'Besht@gmail.com'
  },
  {
    id: 12,
    name: 'Lakshya Khanna',
    username: 'Delphine',
    email: 'CantGetGirlsButCanBeOneHimself@gmail.com'
  },
  {
    id: 13,
    name: 'Lee Eunseo',
    username: 'Delphine',
    email: 'Dog/Cat/Bat-Eater@gmail.com'
  },
  {
    id: 14,
    name: 'Lishika Zope',
    username: 'Delphine',
    email: 'BiggerMustacheThanUrDad@gmail.com'
  },
  {
    id: 15,
    name: 'Neev Gogia',
    username: 'Delphine',
    email: 'TennisGirlKaLover@gmail.com'
  },
  {
    id: 16,
    name: 'Renuka Garg',
    username: 'Delphine',
    email: 'MightHaveRabies@gmail.com'
  },
  {
    id: 17,
    name: 'Siddhi Chougule',
    username: 'Delphine',
    email: 'Minimum2Ton@gmail.com'
  },
  {
    id: 18,
    name: 'Soha Awekar',
    username: 'Delphine',
    email: 'AccentThickerThanJEETextbooks@gmail.com'
  },
  {
    id: 19,
    name: 'Tvisha Tikarya',
    username: 'Delphine',
    email: 'AlwaysDepressed@gmail.com'
  },
  {
    id: 20,
    name: 'Arhan Sinha',
    username: 'Delphine',
    email: 'GiantChild@gmail.com'
  },
  {
    id: 21,
    name: 'Shiv Bhatia',
    username: 'Delphine',
    email: 'OnTheSpectrum@gmail.com'
  },
];
